class LanguageDropdownMenu {
    constructor(selector) {
        if (!selector) return;
        this.body = document.querySelector("body");
        this.container = document.querySelector(selector);
        if ( this.container === null ){
            return;  
        }          
        this.dropdown = this.container.querySelector(".c-dropdown-menu");
        this.init();
    }

    init() {
        this.container.addEventListener("click", (e) => this.toggle(e));
        this.dropdown.addEventListener("click", (e) => e.stopPropagation());
    }

    show() {
        if ( typeof window.avatarMenu === 'object' ){
            window.avatarMenu.hide();
        }
        if ( typeof window.searchBoxDesktop === 'object' ){
            window.searchBoxDesktop.hide();
        }
        this.dropdown.classList.remove("c-hidden");
    }

    hide() {
        this.dropdown.classList.add("c-hidden");
    }

    toggle(event) {
        event.stopPropagation();
        if (this.dropdown.classList.contains("c-hidden")) {
            this.show();
        }
        else {
            this.hide();
        }
    }
}


(function() {
    // Language tab flags by visitor country (Peter, 2026-09-13): from Canada, French shows the Quebec flag; from
    // Mexico, Spanish shows the Mexican one. GTranslate's alt_flags names (fn.js: quebec → fr-qc.svg, mexico →
    // es-mx.svg). The country is tmVisitorStore's (first-visit cookie); this bundle runs before fn.js (defer), so
    // the sync value lands in the settings before the list renders; a first-visit lookup swaps the rendered images.
    let flagsByCountry = { ca: { fr: 'quebec' }, mx: { es: 'mexico' } };
    let flagFiles = { quebec: 'fr-qc', mexico: 'es-mx' };
    let applyVisitorCountryFlags = function (iso2) {
        let flags = flagsByCountry[iso2];
        if (!flags || typeof window.gtranslateSettings !== 'object') { return; }
        window.gtranslateSettings.alt_flags = window.gtranslateSettings.alt_flags || {};
        Object.keys(flags).forEach(function (lang) {
            window.gtranslateSettings.alt_flags[lang] = flags[lang];
            document.querySelectorAll('.cool-gtranslate-wrapper a[data-gt-lang="' + lang + '"] img').forEach(function (img) {
                img.src = 'https://cdn.gtranslate.net/flags/svg/' + flagFiles[flags[lang]] + '.svg';
            });
        });
    };
    if (typeof tmVisitorStore === 'object') {
        applyVisitorCountryFlags(tmVisitorStore.getCountry());
        tmVisitorStore.resolveCountry().then(applyVisitorCountryFlags);
    }

    jQuery(document).ready(function () {
        //window.languageDropdownMenu = new LanguageDropdownMenu(".c-dropdown-menu-wrapper");
    });

    jQuery(document).on('tmModal_open_#c-language-modal', function () {
        if ( typeof window.languageDropdownMenu === 'object' ){
            window.languageDropdownMenu.hide();
        }
    });
})();

